import { useEffect, useState } from 'react';
import Script from 'next/script';
import { useConsent } from 'c15t/react';
import { useUser } from '../users/useUser';
import { ENVIRONMENTS } from '@belong/common';

const clientToken = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_CLIENT_TOKEN;
const applicationId =
  process.env.NEXT_PUBLIC_DATADOG_APPLICATION_APPLICATION_ID;
const buildNumber = process.env.NEXT_PUBLIC_BUILD_NUMBER;
const apiUrl = process.env.NEXT_PUBLIC_API_URL;
const env = process.env.NEXT_PUBLIC_ENV;

const isLocal =
  process.env.NEXT_PUBLIC_ENV === ENVIRONMENTS.DEVELOPMENT ||
  process.env.NODE_ENV === 'development';
const isProduction = env === ENVIRONMENTS.PRODUCTION;

const RUM_SAMPLE_RATE = 10;
const LOGS_SAMPLE_RATE = 50;

export function DataDog() {
  const [isDDRumScriptLoaded, setIsDDRumScriptLoaded] = useState(false);
  const [isDDLogsScriptLoaded, setDDLogsIsScriptLoaded] = useState(false);
  const { user } = useUser();
  const hasMeasurementConsent = useConsent('measurement');

  useEffect(() => {
    if (isDDRumScriptLoaded && isDDLogsScriptLoaded && user?.userId) {
      window.DD_RUM.setUser({
        id: user.userId,
      });

      window.DD_LOGS?.setGlobalContextProperty('user', user.userId);
    }
  }, [isDDRumScriptLoaded, isDDLogsScriptLoaded, user?.userId]);

  if (isLocal) {
    return null;
  }

  return (
    <>
      {isProduction && hasMeasurementConsent && (
        <Script
          id="datadog"
          strategy="lazyOnload"
          src="https://www.datadoghq-browser-agent.com/datadog-rum-v4.js"
          onLoad={() => {
            window.DD_RUM?.onReady(() => {
              window.DD_RUM?.init({
                clientToken,
                applicationId,
                site: 'datadoghq.com',
                service: 'belong-consumer',
                env,
                // Specify a version number to identify the deployed version of your application in Datadog
                version: buildNumber,
                sampleRate: RUM_SAMPLE_RATE,
                trackInteractions: true,
                premiumSampleRate: 0,
                allowedTracingOrigins: [apiUrl],
                silentMultipleInit: true,
              });

              window.DD_RUM?.stopSessionReplayRecording?.();

              setIsDDRumScriptLoaded(true);
            });
          }}
        />
      )}
      <Script
        id="datadog-logs"
        strategy="lazyOnload"
        src="https://www.datadoghq-browser-agent.com/datadog-logs-v4.js"
        onLoad={() => {
          window.DD_LOGS?.onReady(() => {
            window.DD_LOGS?.init({
              clientToken,
              forwardErrorsToLogs: true,
              site: 'datadoghq.com',
              service: 'belong-consumer',
              env,
              version: buildNumber,
              sampleRate: LOGS_SAMPLE_RATE,
              silentMultipleInit: true,
            });

            setDDLogsIsScriptLoaded(true);
          });
        }}
      />
    </>
  );
}
